declare const initSqlJs: any;

export class MBTilesUtil {
  KEY_NAME = 'name';
  KEY_TYPE = 'template';
  KEY_VERSION = 'version';
  KEY_DESCRIPTION = 'description';
  KEY_ATTRIBUTION = 'attribution';
  KEY_CENTER = 'center';
  KEY_BOUNDS = 'bounds';
  KEY_MIN_ZOOM = 'minzoom';
  KEY_MAX_ZOOM = 'maxzoom';

  static loadBinaryFile(path): Promise<Uint8Array> {
    return new Promise<Uint8Array>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', path, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = () => {
        // A refused or missing file answers too, with an error page for a
        // body. Status 0 is a local (file or blob) read that succeeded.
        if (xhr.status !== 0 && (xhr.status < 200 || xhr.status >= 300)) {
          reject(new Error(`MBTiles file could not be downloaded (HTTP ${xhr.status})`));
          return;
        }
        // The bytes as they came: copied a character at a time into a string,
        // which sql.js then turned back into bytes, a large file took several
        // times its size in memory on the main thread and could crash the tab.
        resolve(new Uint8Array(xhr.response));
      };
      xhr.onerror = () => reject(new Error('MBTiles file could not be downloaded'));
      xhr.onabort = () => reject(new Error('MBTiles download was aborted'));
      xhr.send();
    });
  }

  static load(url): Promise<any> {
    // One chain, so a failure anywhere -- the download, sql.js, or a file it
    // cannot open -- rejects. The database used to be opened in a callback
    // nothing waited on: a throw there left the layer loading for ever.
    return this.loadBinaryFile(url)
      .then(data => initSqlJs().then(SQL => new SQL.Database(data)));
  }

  static loadFile(file) {
    const urlCreator = window.URL || window['webkitURL'];
    const path = urlCreator.createObjectURL(file);
    // The URL pins the whole file in memory until it is revoked.
    const release = () => urlCreator.revokeObjectURL(path);
    return this.load(path).then(db => {
      release();
      return db;
    }, error => {
      release();
      throw error;
    });
  }

  static getAllMetadata(db): any {
    const res = db.exec('SELECT * FROM metadata');
    const meta = {};
    if (res.length > 0) {
      const data = res[0].values;
      data.forEach(d => {
        meta[d[0]] = d[1];
      });
    }
    return meta;
  }

  static getMetadata(db, key) {
    const res = db.exec(`SELECT value FROM metadata WHERE name = '${key}'`);
    if (res.length > 0) {
      return res[0].values[0][0];
    }
    return null;
  }

  static getTile(db, zoomLevel, col, row) {
    return db.exec(`SELECT tile_data FROM tiles WHERE zoom_level = ${zoomLevel} AND tile_column = ${col} AND tile_row = ${row}`);
  }
}
